import * as React from 'react';
import { connect } from 'react-redux';
import { SaveAsContent } from '../components';
import { DEFAULT_JOURNEY_ID } from '../constants';
import { saveHelper, EModalType, IToolsState } from '../helpers';
import store from '../store/store';
import types from '../store/types';

class SaveAsContainer extends React.Component<any, any> {

	titleChange = (val: string) => {
		store.dispatch({
			type: types.SAVE_AS_JOURNEY_TITLE_CHANGE,
			journeyTitle: val
		});
	}

	saveJourneyAs = () => {

		let toolsState: IToolsState = store.getState().toolsState;
		let saveAsToolsState: IToolsState = {
			journeyId: DEFAULT_JOURNEY_ID ,
			journeyTitle: this.props.state.journeyTitle,
			isSharedJourney: toolsState.isSharedJourney,
			isTriageJourney: toolsState.isTriageJourney,
			hideSteps: toolsState.hideSteps,
			replaceGuids: toolsState.replaceGuids,
			isSaveAndResume: toolsState.isSaveAndResume,
			Properties: toolsState.Properties,
			saving: false
		};

		saveHelper(DEFAULT_JOURNEY_ID , saveAsToolsState, store.getState().processState).then(
			() => {
				store.dispatch({
					type: types.UPDATE_JOURNEY_TITLE,
					journeyTitle: this.props.state.journeyTitle
				});
				store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
			}
		);
	}

	closeDialog = () => {
		store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
	}

	public render () {

		return (
			<SaveAsContent 
				journeyTitle={ this.props.state.journeyTitle }
				titleChange={ this.titleChange }
				saveJourneyAs={ this.saveJourneyAs }
				closeDialog={ this.closeDialog }
				isSaving={ this.props.isSaving }
			/>
		);

	}

}

let mapStateToProps = (store) => {
  return {
	state: store.modalState.saveAs,
	isSaving: store.toolsState.saving
  };
};

export default connect<any, any, any>(mapStateToProps)(SaveAsContainer);


// WEBPACK FOOTER //
// ./source/ts/containers/save-as.tsx